<template>
  <div>
    <div class="banner">和优秀的人，做有挑战的事</div>

    <div class="news-center">
      <h1>新闻中心</h1>

      <div class="news-tabs">
        <button v-for="(tab, index) in tabs" :key="index" 
                :class="{ active: currentTab === index }"
                @click="currentTab = index">
          {{ tab.name }}
        </button>
      </div>

      <div class="news-list">
        <div v-for="news in paginatedNews" :key="news.id" class="news-card">
          <div class="news-date">{{ formatDate(news.date) }}</div>
          <img :src="getFullImageUrl(news.image)" :alt="news.title" class="news-image" />
          <div class="news-info">
            <h2 class="news-title">{{ news.title }}</h2>
            <p class="news-summary">{{ news.summary }}</p>
          </div>
          <button class="details-button" @click="viewDetails(news.id)">➔</button>
        </div>
      </div>

      <div class="pagination">
        <button @click="prevPage" :disabled="currentPage === 1">上一页</button>
        <span>第 {{ currentPage }} 页，共 {{ totalPages }} 页</span>
        <button @click="nextPage" :disabled="currentPage === totalPages">下一页</button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { getNewsList } from "@/api/news";
export default {
  name: 'NewsCenter',
  data() {
    return {
      tabs: [
        { name: '公司动态', category: 'company' },
        { name: '行业动态', category: 'industry' },
        { name: '常见问题', category: 'faq' }
      ],
      currentTab: 0,
      currentPage: 1,
      newsPerPage: 5,
      newsItems: [],        // 新闻列表
      loading: false,       // 加载状态
      total: 0,             // 总条数（用于分页）
      isLoading: false      // 请求状态标志位
    };
  },
  computed: {
    filteredNews() {
      const category = this.tabs[this.currentTab].category;
      return this.newsItems.filter(news => news.category === category);
    },
    paginatedNews() {
      const startIndex = (this.currentPage - 1) * this.newsPerPage;
      return this.filteredNews.slice(startIndex, startIndex + this.newsPerPage);
    },
    totalPages() {
      return Math.ceil(this.filteredNews.length / this.newsPerPage);
    }
  },
  methods: {
    async fetchNewsList(category = "", page = 1) {
      if (this.isLoading) return; // 防止并发请求

      this.isLoading = true;
      this.loading = true;
      console.log(`Fetching news list for category: ${category}, page: ${page}`);

      try {
        const res = await getNewsList({ category, page, limit: this.newsPerPage });

        if (res.data.status === 200) {
          this.newsItems = res.data.data.list; // 替换旧数据
          this.total = res.data.data.total;
          this.currentPage = page; // 更新当前页码
        } else {
          this.$message.error(res.data.msg || "获取新闻失败");
        }
      } catch (err) {
        console.error("获取新闻列表失败:", err);
        this.$message.error("网络错误，加载新闻失败");
      } finally {
        this.loading = false;
        this.isLoading = false;
      }
    },
    getFullImageUrl(imagePath) {
      return this.$serverUrl + imagePath;
    },
    viewDetails(newsId) {
      this.$router.push(`/news/${newsId}`);
    },
    formatDate(date) {
      const options = { year: 'numeric', month: 'short', day: 'numeric' };
      return new Date(date).toLocaleDateString('zh-CN', options);
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        const category = this.tabs[this.currentTab].category;
        this.fetchNewsList(category, this.currentPage);
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        const category = this.tabs[this.currentTab].category;
        this.fetchNewsList(category, this.currentPage);
      }
    }
  },
  watch: {
    currentTab(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.currentPage = 1; // 重置当前页
        this.total = 0;       // 重置总条数
        const category = this.tabs[newVal].category;
        this.fetchNewsList(category, 1);
      }
    },
    currentPage(newVal, oldVal) {
      if (newVal !== oldVal) {
        const category = this.tabs[this.currentTab].category;
        this.fetchNewsList(category, newVal);
      }
    }
  },
  async created() {
    // 初始化加载全部新闻（不分类型）
    const category = 'company';
    await this.fetchNewsList(category, 1);

    // 如果你想按 tab 分类请求，可以改为：
    // const category = this.tabs[this.currentTab].category;
    // await this.fetchNewsList(category, 1);
  }
};
</script>

<style scoped>
	
.banner {
  height: 150px;
  line-height: 150px;
  color: #fff;
  width: 100%;
  min-width: @main-width;
  background-image: url("../../assets/images/news.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  text-align: center;
  font-size: @font-size-larger;
}	
	
.news-center {
  padding: 20px;
  width: 70%;
  margin: auto;
}

.news-tabs {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
  height: 50px;
}

.news-tabs button {
  background-color: #f4f4f4;
  border: none;
  padding: 10px 20px;
  font-size: 1em;
  margin: 0 10px;
  cursor: pointer;
  border-radius: 4px;
  width: 20%;
  transition: background-color 0.3s, transform 0.1s;
}

.news-tabs button.active {
  background-color: #007bff;
  color: white;
}

.news-tabs button:hover:not(.active) {
  background-color: #ddd;
}

.news-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.news-card {
  display: flex;
  align-items: center;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s;
  
}

.news-card:hover {
  transform: translateY(-5px);
}

.news-date {
  font-size: 1em;
  color: #999;
  margin-right: 20px;
  flex-shrink: 0;
  width: 100px;
  text-align: center;
}

.news-image {
  width: 150px;
  height: 120px;
  border-radius: 8px;
  margin-right: 20px;
  object-fit: cover;
  flex-shrink: 0;
}

.news-info {
  flex: 1;
}

.news-title {
  font-size: 1.5em;
  margin: 10px 0;
}

.news-summary {
  color: #555;
  margin: 8px 0;
}

.details-button {
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 50%;
  background-color: #007bff;
  color: white;
  font-size: 1.5em;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.3s, transform 0.1s;
  margin-left: 20px;
}

.details-button:hover {
  background-color: #0056b3;
}

.details-button:active {
  transform: scale(0.9);
}

.pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: auto;
  margin-top: 40px;
}

.pagination button {
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 8px 12px;
  cursor: pointer;
  margin: auto;
  transition: background-color 0.3s;
}

.pagination button:hover {
  background-color: #0056b3;
}

.pagination span {
  font-size: 1em;
}
</style>
